import { ActivatedRouteSnapshot, Routes } from "@angular/router";
import { notNull } from "@lib/base/utils/object.utils";

export const getAllSnapshots = (snapshot: ActivatedRouteSnapshot, arr: Array<ActivatedRouteSnapshot> = []): Array<ActivatedRouteSnapshot> => {
    arr.push(snapshot);
    if (snapshot.firstChild == null) return arr;
    return getAllSnapshots(snapshot.firstChild);
};

export const doesSnapshotRouteExists = (snapshot: ActivatedRouteSnapshot, route: string) => {
    return flattenSnapshotRoutes(snapshot).some(flattenedRoute => flattenedRoute === route);
};

type WithLoadedRoutes = ActivatedRouteSnapshot & {
    _loadedRoutes: Routes;
};

export const flattenSnapshotRoutes = (snapshot: ActivatedRouteSnapshot | null, childRoute: string[] = []): string[] => {
    if (snapshot == null || snapshot.parent == null) return childRoute;
    const parent = snapshot.parent;
    const routeConfig = parent.routeConfig;
    if (routeConfig == null || (parent.routeConfig as WithLoadedRoutes)._loadedRoutes == null) return childRoute;
    const parentRoutes = (parent.routeConfig as WithLoadedRoutes)._loadedRoutes.filter(e => e.component != null || e.loadComponent != null || e.redirectTo != null).map(e => e.path === "" ? routeConfig.path : routeConfig.path + "/" + e.path).filter(notNull) ?? [];
    const prefixedChildRoutes = childRoute.map(e => routeConfig.path + "/" + e);
    return flattenSnapshotRoutes(parent, [...parentRoutes, ...prefixedChildRoutes]);
};
